import styled from "@emotion/styled";
export const StyledOutlineButtonWithMenuComponent = styled.div`
  position: relative;

  .button-wrapper {
    display: inline-flex;
    align-items: center;
  }

  .menu-content-wrapper {
    position: absolute;
  }
`;
